export const boxShadows = {
  '0': '0 0px 0px 0',
  '1': '0 1px 3px -1px rgba(0, 0, 0, 0.4)',
  '2': '0 0.5px 2px -1px rgba(0, 0, 0, 0.34), 0 3px 6px -2px rgba(0, 0, 0, 0.36)',
  '3': '0 1px 3px -1px rgba(0, 0, 0, 0.34), 0 5px 10px -2px rgba(0, 0, 0, 0.32)',
  '4': '0 1.5px 4px -1px rgba(0, 0, 0, 0.34), 0 8px 20px -3px rgba(0, 0, 0, 0.28)',
  '5': '0 1.5px 4px -1px rgba(0, 0, 0, 0.3), 0 10px 35px -4px rgba(0, 0, 0, 0.25)',
};
